import { Roles } from '@typings/roles'

const TRAINING_COMPANY_ROLES = [Roles.INSTRUCTOR, Roles.TRAINING_COMPANY_MANAGER]

export const canTrainingCompany = (role: Roles) => {
  return TRAINING_COMPANY_ROLES.includes(role)
}
